import React from 'react';
import { Box, Typography } from '@mui/material';
import Dashboard from './Dashboard';

const AdminDashboard = () => {
  return <Dashboard />;
};

export default AdminDashboard;
